import { minuteMs } from "verdi-common/timeConstants";
import { useListDataStreams } from "@/api/orval/generated/data-stream";

export function useOrgDataStreams(enabled: boolean) {
    return useListDataStreams({}, { query: { enabled, staleTime: 30 * minuteMs } });
}
